(function () {
    'use strict';

    angular.module('app').factory('TransactionService', TransactionService);

    TransactionService.$inject = ['$rootScope', 'API', '$filter'];

    function TransactionService($rootScope, API, $filter) {
        var service = {};

        /**
         * Get list of all or filtered Transactions
         */
        service.All = function (params, callback) {
            API.get('/transactions?{0}'.format(paramsToUrlQueryEncodeURIComponent(params)), callback, true);
        };

        service.AddBonuses = function (post_data, callback) {
            API.post('/transactions/bonuses/add', post_data, function (success, data) {
                if (success) {
                    // NotifyService.Success(data.message, false);
                }
                callback(success, data);
            });
        };

        service.WriteOffsBonuses = function (post_data, callback) {
            API.post('/transactions/bonuses/write_offs', post_data, function (success, data) {
                if (success) {
                    // NotifyService.Success(data.message, false);
                }
                callback(success, data);
            });
        };

        service.AdjustBonuses = function (post_data, callback) {
            API.post('/transactions/bonuses/adjust', post_data, function (success, data) {
                callback(success, data);
            });
        };

        service.RefillSpecialAccounts = function (post_data, callback) {
            API.post('/transactions/special_account/refill', post_data, function (success, data) {
                callback(success, data);
            });
        };

        service.WriteOffSpecialAccounts = function (post_data, callback) {
            API.post('/transactions/special_account/write_offs', post_data, function (success, data) {
                callback(success, data);
            });
        };

        service.AdjustmentSpecialAccounts = function (post_data, callback) {
            API.post('/transactions/special_account/adjust', post_data, function (success, data) {
                callback(success, data);
            });
        };

        service.GetTransactionCheck = function (id, callback) {
            API.get(`/transactions/${id}/check`, function (success, response) {
                if (success) {
                }
                callback(success, response);
            });
        };

        service.GetTransactionOrder = function (id, callback) {
            API.get(`/transactions/${id}/order`, function (success, response) {
                if (success) {
                }
                callback(success, response);
            });
        };

        service.GetTransactionReceipt = function (id, callback) {
            API.get('/transactions/' + id + '/receipt', function (success, response) {
                if (success) {
                }
                callback(success, response);
            });
        };

        service.CancelTransaction = function (post_data, callback) {
            API.post('/transactions/cancel', post_data, function (success, data) {
                if (success) {
                    // NotifyService.Success(data.message, false);
                }
                callback(success, data);
            });
        };

        service.FinalizeTransaction = function (post_data, callback) {
            API.post('/transactions/finalize', post_data, function (success, data) {
                if (success) {
                    // NotifyService.Success(data.message, false);
                }
                callback(success, data);
            });
        };

        service.getPumpNozzle = function (item) {
            return (item.additions && item.additions.job) ?
                `(${$filter('translate')('Pump')} ${item.additions.job.details.fuel.pump} / ${$filter('translate')(
                    'Nozzle')} ${item.additions.job.details.fuel.nozzle})`
                : '';
        };

        return service;
    }

})();
